import { render, staticRenderFns } from "./pendaftaran.vue?vue&type=template&id=6f7794e0&"
import script from "./pendaftaran.vue?vue&type=script&lang=js&"
export * from "./pendaftaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports